import _classCallCheck from "/home/vsts/work/1/s/Code/WebApp/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/Code/WebApp/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */

/**
 * @class
 * Class representing MiddlewareControl
 */
export var MiddlewareControl =
/*#__PURE__*/
function () {
  /**
   * @public
   * @constructor
   * Creates an instance of MiddlewareControl
   * @param {MiddlewareOptions[]} [middlewareOptions = []] - The array of middlewareOptions
   * @returns The instance of MiddlewareControl
   */
  function MiddlewareControl() {
    var middlewareOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    _classCallCheck(this, MiddlewareControl);

    // tslint:disable-next-line:ban-types
    this.middlewareOptions = new Map();
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = middlewareOptions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var option = _step.value;
        var fn = option.constructor;
        this.middlewareOptions.set(fn, option);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }
  /**
   * @public
   * To get the middleware option using the class of the option
   * @param {Function} fn - The class of the strongly typed option class
   * @returns The middleware option
   * @example
   * // if you wanted to return the middleware option associated with this class (MiddlewareControl)
   * // call this function like this:
   * getMiddlewareOptions(MiddlewareControl)
   */
  // tslint:disable-next-line:ban-types


  _createClass(MiddlewareControl, [{
    key: "getMiddlewareOptions",
    value: function getMiddlewareOptions(fn) {
      return this.middlewareOptions.get(fn);
    }
    /**
     * @public
     * To set the middleware options using the class of the option
     * @param {Function} fn - The class of the strongly typed option class
     * @param {MiddlewareOptions} option - The strongly typed middleware option
     * @returns nothing
     */
    // tslint:disable-next-line:ban-types

  }, {
    key: "setMiddlewareOptions",
    value: function setMiddlewareOptions(fn, option) {
      this.middlewareOptions.set(fn, option);
    }
  }]);

  return MiddlewareControl;
}();